import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fires a fire-and-forget pageview beacon on every route change.
 * Skips /admin, /login and any 404 renders. A ref-based dedupe
 * suppresses the duplicate call from React 18 StrictMode.
 */
export const usePageAnalytics = () => {
  const location = useLocation();
  const lastFired = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/admin') || path.startsWith('/login')) return;
    if (lastFired.current === path) return;
    lastFired.current = path;

    axios
      .post(`${API_URL}/api/analytics/pageview`, {
        path,
        referrer: document.referrer || null,
      })
      .catch(() => {
        // Fail silently — analytics must never break the UX.
      });
  }, [location.pathname]);
};
